"use client";
import { brokerConnectModalAtom } from "@/Atoms/modal/DialogueAtoms";
import React from "react";
import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";

function BrokerConnectButton({ link }: { link?: boolean }) {
  const [showConnectForm, setShowConnectForm] = useRecoilState(
    brokerConnectModalAtom
  );
  const { t } = useTranslation("deploy-live");

  return (
    <div
      id="connect-to-broker-deploy-live2"
      className={
        "w-full text-xs whitespace-wrap cursor-pointer  flex flex-col justify-center items-center  "
      }
    >
      <div
        className={`flex flex-col justify-center items-center `}
        onClick={() => {
          setShowConnectForm(true);
        }}
      >
        <div className="flex items-center cursor-pointer ">
          <div className="w-[10px] h-[10px] rounded-xl bg-[--marketplace-red]"></div>
          <div className="ml-2">
            <p className="text-muted-foreground font-bold text-xs whitespace-nowrap">
              Broker Not Connected{" "}
            </p>
          </div>
        </div>

        <span className="text-[--marketplace-red] text-sm font-bold">
          {t("Click to connect now")}
        </span>
      </div>
      {false && (
        <a
          className="text-blue-500 underline"
          href="https://learn.trylevel2.com/docs/technical/virtual-trading"
        >
          Virtual trading guide
        </a>
      )}
    </div>
  );
}

export default BrokerConnectButton;
